import createReducer from "../../createReducer";
import { mailchimpAuthHandlers } from "../handlers";
import { IMailchimpAuthState } from "../types";

export const mailchimpInitialState: IMailchimpAuthState = {
    isLoading: false,
    error: null,
    authUrl: null,
};

export default createReducer(mailchimpInitialState, mailchimpAuthHandlers);
